import { render, staticRenderFns } from "./awaitDialog.vue?vue&type=template&id=20ee47b2&scoped=true"
import script from "./awaitDialog.vue?vue&type=script&lang=js"
export * from "./awaitDialog.vue?vue&type=script&lang=js"
import style0 from "./awaitDialog.vue?vue&type=style&index=0&id=20ee47b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee47b2",
  null
  
)

export default component.exports